export enum SkeletonVariants {
  CIRCLE = 'circle',
  RECTANGLE = 'rectangle',
  TEXT = 'text',
}
